<template>
  <div class="chart-container">
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <span>{{$t('logbook')}}</span>
      </div>
      <div class="main-header-right">
        <button @click="print"><span>{{$t('print')}}</span></button>
        <button class="set" @click="open"><span>{{$t('set')}}</span></button>
        <p>{{$t('period')}}:<span class="time">{{timeRange}}</span></p>
      </div>
    </div>
    <hr class="small-hr spe-hr">
    <div class="main-wrapper" id="table-wrapper">
        <div class="table-left" :class="{'zh66':!isEn}"  id="table-left">
          <div id="title-table2" class='searchBar'>
          <table style="width: 100%">
            <tr style="height: 25px">
              <td style="width:30%">{{$t('date')}}</td>
              <td style="width:70%" class="spe-td2" >{{$t('dailyTotal')}}
               <!-- <span style="float: right">00</span>--></td>
            </tr>
          </table>
          </div>
          <div id="wrap1" class="searchBarTd">
            <div id="context-table1">
              <table v-for="(item,index) in whichDate" :id="'date'+index">
                <tr>
                  <td rowspan="4"  style="width:30%" class="spe-td">{{item}}</td>
                  <td style="width: 20%" class="spe-td">{{$t('BG')}}</td>
                  <td style="width: 50%" class="spe-td">{{bgAvg[index].avg}}</td>
                </tr>
                <tr>
                  <td>{{$t('carbs')}}</td> <td>{{carb[index].total}}</td>
                </tr>
                <tr>
                  <td>{{$t('insulin')}}</td> <td>{{ins[index].total}}:{{$t('bolus')}}: {{ins[index].percent}}%</td>
                </tr>
                <tr>
                   <td>{{$t('events')}}</td> <td></td>
                </tr>
              </table>

            </div>

          </div>
          <div id="sliderWrap">
            <div id="slider" @mousedown = drag($event)></div>
          </div>

        </div>

        <div class="table-right" id="table-right">
          <div class="tip" :class="{'po6':isPo,'fr6':isFr}">
            <span id="m0">{{$t('Breakfast')}}</span> <span id="m1">{{$t('Lunch')}}</span> <span id="m2">{{$t('Dinner')}}</span>
          </div>
          <div id="title-table" class='searchBar'>
            <table class="table2 table4 searchBarRight" >
              <tr style="height: 25px">
                <td v-for="i in hours" class="spe-td3" :class="{'spe-td4':(i==='23:00'),'spe-td5':(i==='00:00')}">
                 <span>{{i}}</span>
                </td>
              </tr>
             </table>
          </div>
          <div id="wrap">
            <table class="table2" id="context-table">
            <tr v-for="i in (whichDate.length*4)" :id="i">
              <td v-for="i in 24" class="spe-td"></td>
            </tr>
           </table>
          </div>
        </div>
    </div>
    <div class="legend-group" :class="{'zh8':!isEn,'es8':isEs,'de8':isDe,'it8':isIt,'po8':isPo,'du8':isDu||isCz,'fr8':isFr,'sw8':isSw}">
      <div class="legend"><img src="../../assets/chart5-icon/High Patch.png" class="img-spe"><span>{{$t('High Glucose')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/low Glucose.png" class="img-spe"><span>{{$t('Low Glucose')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/middle Glucose.jpg" class="img-spe"><span>{{$t('t1112_Normal_Glucose')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/No Active Patch.png" class="img-spe"> <span>{{$t('No Active Patch')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/temp basal.png" class="img-spe"><span>{{$t('tempBasal')}}</span></div>
      <div class="legend"><img src="../../assets/chart5-icon/Manual Suspend.png" class="img-spe"><span>{{$t('manualStop')}}</span></div>
      <div class="legend" :class="{'de12':isDe}"><img src="../../assets/chart5-icon/Auto Suspend.png" class="img-spe"><span>{{$t('autoStop')}}</span></div>
      <div class="legend" :class="{'zh9':!isEn,'es9':isEs,'de9':isDe,'sw9':isSw}"><img src="../../assets/chart5-icon/Missed Meal.png" class="img-spe1"><span>{{$t('Missed Meal')}}</span></div>
      <div class="legend spe2" :class="{'zh10':!isEn,'es10':isEs,'de10':isDe,'cz10':isCz}"><img src="../../assets/chart5-icon/Stop Patch .png"><span>{{$t('Stop Patch')}}</span></div>
      <div class="legend spe3" :class="{'zh14':!isEn,'es11':isEs,'cz11':isCz}"><img src="../../assets/chart5-icon/Bolus.png" class="img-spe2"> <span>{{$t('t1112_Manual_Bolus_or_Modified_Bolus')}}</span></div>
      <div class="legend spe4" :class="{'zh11':!isEn,'es12':isEs,'cz12':isCz}"><img src="../../assets/chart5-icon/New Patch .png"><span>{{$t('newPatch')}}</span></div>
      <div class="legend spe5" :class="{'zh12':!isEn,'es13':isEs}"><img src="../../assets/chart5-icon/Others.png"><span>{{$t('Other Events')}}</span></div>
      <div class="legend spe6" :class="{'es15':isEs}"><img src="../../assets/chart5-icon/Exercise.png"><span>{{$t('exercise')}}</span></div>
      <div class="legend spe1"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/chart5-icon/Mutiple Readings.png"><span>{{$t('Multiple BG Readings')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/运动[30059].png"><span>{{$t('Exercise')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/进入自动模式.png"><span>{{$t('t1112_Auto_Mode_Started')}}</span></div>
      <div class="legend spe7"  :class="{'zh13':!isEn,'es16':isEs}"><img src="../../assets/Hcp-icon/legend/automode/退出自动模式.png"><span>{{$t('t1112_Auto_Mode_Exit')}}</span></div>
    </div>

    <!--Add对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="duration" >
          <span>{{$t('duration')}}</span>
          <select id="duration"  @change = "procTimeRangeSelect" v-model="timeRangeSelect">
            <option value="1">{{$t('7 days')}}</option>
            <option value="2">{{$t('14 days')}}</option>
          </select>
        </div>

        <div class="time-range" :class="{'zh2':!isEn}">
          <div class="start">
            <p>{{$t('From')}}</p>
            <div class="block">
              <!--
              <el-date-picker v-model="value1" type="date"  :editable=false  :placeholder="defaultDate1"
                              :clearable=false  :picker-options="pickerOptions"   format="dd-MM-yyyy" >
              </el-date-picker>-->
              <p>{{defaultDate1}}</p>
            </div>
          </div>
          <div class="end">
            <p class="to" :class="{'zh6':!isEn}">{{$t('To')}}</p>
            <div class="block date1">
              <el-date-picker v-model="value2" type="date"  :editable=false @change="endDateChange" :placeholder="defaultDate2"
                              :clearable=false  :picker-options="pickerOptions"  format="dd-MM-yyyy" >
              </el-date-picker>
            </div>
          </div>
        </div>
        <hr class="patientList-small-hr">
        <div class="weeks" id="weeks" :class="{'zh3':!isEn}">
          <span class="tittle" :class="{'zh4':!isEn}"><label @click="chooseAll" >{{$t('Weekdays')}}</label></span>
          <span><label @click="choose" >{{$t('Mon')}}</label></span>
          <span><label @click="choose">{{$t('Tue')}}</label></span>
          <span><label @click="choose">{{$t('Wed')}}</label></span>
          <span><label @click="choose">{{$t('Thur')}}</label></span>
          <span><label @click="choose">{{$t('Fri')}}</label></span>
        </div>
        <div class="weeks weken" id='weken' :class="{'zh3':!isEn}">
          <span class="tittle" :class="{'zh5':!isEn,'de5':isDe,'it5':isIt,'po5':isPo,'du5':isDu,'sw5':isSw,'cz5':isCz}"><label @click="chooseAll" >{{$t('Weekends')}}</label></span>
          <span><label @click="choose">{{$t('Sat')}}</label></span>
          <span  :class="{'it2':isIt,'po2':isPo,'du2':isDu,'fr3':isFr,'sw2':isSw,'cz2':isCz}"><label @click="choose">{{$t('Sun')}}</label></span>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        pump_device:'--',
        timer: false,typeChooseVisible:false, value1:'',value2:'',isC:false, flag:0,count:0, sta:'',end:'',isMg:'',ts:[],tz:[],noPump:[],isEs:false,isDe:false,isCz:false,
        uid:0, st:0,et:0,autoStop:[],manualStop:[],stop:[],Newer:[],noMeal:[],mt:[],dialogSize:'tiny',mt1:[],weekModeSp:[],weekM1:false,weekM2:false,isSw:false,
        bgAvg:[{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},
          {avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",}],
        bgAvg1:[{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},
          {avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",},{avg:"--",}],
        carb:[{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},
          {total:"--",},{total:"--",},{total:"--",},{total:"--",}],
        carb1:[{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},{total:"--",},
          {total:"--",},{total:"--",},{total:"--",},{total:"--",}],
        ins:[{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},],
        ins1:[{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},
          {total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},{total:"--",percent:"--"},],
        chartColumn: null, defaultDate1:'', defaultDate2:'',whichDay:'Everyday', weekmode:'yyyyyyy',timeRange:'', isA:false,isPo:false,isDu:false,isFr:false,
        whichDate:[],timeRangeSelect:1,
        whichDate1:['','','','','','','','','','','','','',''],
        hours:['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00',
          '11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },
        isEn:false,
        wrapDiv:'',contentDiv:'',contentDiv1:'',sliderWrap:'',slider:'',disX:'',disY:'',mouseFlag:true,isIt:false,
      }
    },
    computed: {
      DataS(){
        return this.$store.state.DataS;
      },
      DataSG(){
        return  JSON.parse(sessionStorage.getItem('olDataSG'));
      },
    },
    methods:{
      getData(){
        //console.log('getData.1')
        this.ts = this.getTs(this.st,this.et);
        //console.log('getData.2')
        let param = {
          ts:this.ts,
          tz:this.tz,
          gu:(this.isMg)?'mg/dL':'mmol/L',
          weekmode:this.weekmode,
        };
        //
        let daysNum=this.ts.length;
        let w1=document.getElementById("wrap");
        let w2=document.getElementById("wrap1");
        let w3=document.getElementById("sliderWrap");
        let w4=document.getElementById("table-wrapper");
        w1.style.height=(0+124*daysNum)+'px';
        w2.style.height=(0+124*daysNum)+'px';
        w3.style.height=(0+124*daysNum)+'px';
        w4.style.height=(100+124*daysNum)+'px';
        //
        this.bgAvg = this.bgAvg1;
        this.carb = this.carb1;
        this.ins = this.ins1;
        param = B64.base64encode(JSON.stringify(param));
        auth.getLgb1(this,this.uid,param);
      },
      cancel(){
        this.typeChooseVisible=false;
      },
      open(){
        this.typeChooseVisible=true;
        auth.checkWeekMode(this);
        this.$nextTick(this.initWeeks);/*不能传参，未封装待优化*/
      },
      initWeeks(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        const labels1 = weeks.getElementsByTagName('label');
        const labels2 = weken.getElementsByTagName('label');
        labels1[0].className=(this.weekM1)?'no':'';
        labels2[0].className=(this.weekM2)?'no':'';
        for(let i=1;i< labels1.length;i++){
          labels1[i].className=(this.weekModeSp[i-1])?'no':'';
        }
        for(let i=1;i< labels2.length;i++){
          labels2[i].className=(this.weekModeSp[i+4])?'no':'';
        }
      },
      procTimeRangeSelect(e){
        console.log('procTimeRangeSelect:', this.timeRangeSelect);
        let daySpan=0;
        if (1==this.timeRangeSelect){   // 7天
          daySpan=7;
        } else if (2==this.timeRangeSelect){  // 14天
          daySpan=14;
        }
        //
        console.log('daySpan:', daySpan);
        if (daySpan) {
          this.st=this.et-86400*(daySpan-1);
          this.defaultDate1=format.formatterDate4(this.st);
          this.value1=new Date(this.st*1000);
        }
      },
      endDateChange(){
        let endDate=this.value2;    // 选择的结束时间。
        this.et=endDate.getTime()/1000;  // unix 时间戳
        let daySpan=0;
        if (1==this.timeRangeSelect) {
          daySpan=7;
        } else if (2==this.timeRangeSelect){
          daySpan=14;
        }
        //
        if (daySpan) {
          this.st=this.et-86400*(daySpan-1);  // 计算起始时间
          this.value1=new Date(this.st*1000);  // 开始时间控件的变量
          this.defaultDate1 = format.formatterDate4(this.st); // 开始时间的显示。
        }
      },
      dateApply(){
        //console.log('dateApply:'+this.value1+','+this.value2);
        let prev_st=this.st;
        let prev_et=this.et;
        //
        if(this.value1&&this.value2) {
          //console.log('dateApply.1:');
          this.st = this.value1.getTime()/1000;
          this.et = this.value2.getTime()/1000;
        } else if(!this.value2&&this.value1){
          //console.log('dateApply.2:');
          this.st = this.value1.getTime()/1000;
          let t = this.defaultDate2.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else if(!this.value1&&this.value2){
          //console.log('dateApply.3:');
          this.et = this.value2.getTime()/1000;
          let t = this.defaultDate1.split('-');
          this.st = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }
        let count = (this.et-this.st)/86400+1;

        console.log('dateApply.4:'+this.st+','+this.et+','+count)
        console.log('dateApply.5:'+prev_st+','+prev_et)

        if (count<=0) {
          try{
            this.st=prev_st;
            this.et=prev_et;
            this.value1=new Date(prev_st*1000);
            this.value2=new Date(prev_et*1000);
          } catch (e) {
          }

          this.$message.error(this.$t('dateErr2'));
        } else if(this.st<=this.et){
          if (count>14 || count<=0) {
            try{
              this.st=prev_st;
              this.et=prev_et;
              this.value1=new Date(prev_st*1000);
              this.value2=new Date(prev_et*1000);
            } catch (e) {

            }

            this.$message.error(this.$t('Date no more than 14 days'));
          } else {
            let weekmode = this.checkDate();
            if(weekmode!=='nnnnnnn'){
              this.weekmode = weekmode;
              let st = format.formatterDate2(this.st);
              let et = format.formatterDate2(this.et);
              this.formatterSelect(st,et);
              this.timeRange = st+'-'+et+', '+this.$t(this.whichDay);
              sessionStorage.setItem('st5',this.st);
              sessionStorage.setItem('et5',this.et);
              sessionStorage.setItem('week5',this.weekmode);
              sessionStorage.setItem('timeRange5',this.timeRange);

              this.isA = (count>7)?true:false;
              if (count<=14) {
                this.getData();
              }
            }
          }
        }
        this.typeChooseVisible=false;
      },
      checkDate(){
        const weeks = document.getElementById('weeks');
        const weken = document.getElementById('weken');
        if(weeks){
          const labels1 = weeks.getElementsByTagName('label');
          const labels2 = weken.getElementsByTagName('label');
          let  weekmode='';
          if(labels1[0].className===''&&labels2[0].className===''){this.whichDay= 'Everyday';weekmode='yyyyyyy';}
          else{
            this.whichDay=' ';weekmode='';
            for(let i=1;i< labels1.length;i++){
              if(labels1[i].className===''){
                this.whichDay = this.whichDay+' '+labels1[i].innerHTML+'.';
                weekmode = weekmode+'y';
              }else{
                weekmode = weekmode+'n';
              }
            }
            for(let i=1;i< labels2.length;i++){
              if(labels2[i].className===''){
                this.whichDay = this.whichDay+' '+labels2[i].innerHTML+'.';
                weekmode = weekmode+'y';
              }else{
                weekmode = weekmode+'n';
              }
            }
          }
          return weekmode;
        }
      },
      choose(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        if(e.target.className===''){
          e.target.className = 'no';
          labels[0].className = 'no';
        }else{
          e.target.className = '';
          for(let i=1;i<labels.length;i++){
            if(labels[i].className===''){
              this.count++;}
          }
          if(this.count===labels.length-1){
            labels[0].className = '';
          }
          this.count = 0;
        }
      },
      chooseAll(e){
        const parent = e.target.parentNode.parentNode;
        const labels =parent.getElementsByTagName('label');
        this.flag =(labels[0].className==='no')?1:0;/*初始化，判断接下来的点击是否全选*/
        for(let i=0;i<labels.length;i++){
          if(this.flag===0){
            labels[i].className = 'no';
          }else{
            labels[i].className = '';
          }
        }
      },
      formatterSelect(st,et){
        st = st.split('/');
        et = et.split('/');
        this.defaultDate1 = st[0]+'-'+st[1]+'-'+st[2];
        this.defaultDate2 = et[0]+'-'+et[1]+'-'+et[2];
      },

      initTable(){
        const table = document.getElementById('context-table');
        const tr = table.getElementsByTagName('tr');
        for(let j=0;j<tr.length;j++){
            const td = tr[j].getElementsByTagName('td');
            for(let k=0;k<td.length;k++){
              td[k].innerHTML ='';
              td[k].style.backgroundColor ='#fff';
            }
          }
        let length1 = this.ts.length;
        for(let i=0;i<length1;i++) {
            let id = 'date'+i;
            const table = document.getElementById(id);
            const tr = table.getElementsByTagName('tr')[2];
            const td = tr.getElementsByTagName('td')[1];
            td.style.backgroundColor = '#fff';
        }
        this.scroll();
      },
      print(){
        sessionStorage.setItem('whichDate5',JSON.stringify(this.whichDate));
        sessionStorage.setItem('lgb_pump_device',this.pump_device);
        window.open('/#/chart5-print','_blank');
      },
      getTs(st,et){
        let ts =[],days =(et-st)/86400+1,time=0,sp1=0,k=0;
        let No = auth.chekcNoDate(this.weekmode);
        this.whichDate = [];
        for(let i=0;i<days;i++){
          let day = new Date((st+i*86400)*1000).getDay();
           if(No.indexOf(day)===-1){
             ts[k] = [];
             ts[k][0] = st+i*86400;
             ts[k][1] = st+(i+1)*86400;
             time = new Date(ts[k][0]*1000).toString();
             sp1 = time.split(' ');
             if(this.isEn){
               this.whichDate[k] = sp1[2]+' '+this.$t(sp1[1])+', '+sp1[3]+' '+this.$t(sp1[0]);
             }else{
               let m = new Date(ts[k][0]*1000).getMonth()+1;
               m=(m<10)? '0'+m:m;
               this.whichDate[k] = sp1[3]+'-'+m+'-'+sp1[2]+' '+this.$t(sp1[0]);
             }
             k++;
           }
        }
        return ts;
      },
      makebg1(val,high,low){
        for(let i=0;i<val.length;i++){
          if(val[i].length>0){
            let id = i*4+1;
            const tr = document.getElementById(id);
            //console.log('makebg1:', tr, i, id);
            for(let j=0;j<val[i].length;j++){
                if(val[i][j].length>0){
                  const td = tr.getElementsByTagName('td')[j];
                  if(val[i][j].length===2){
                    let div1 =document.createElement('div');
                    let div2 =document.createElement('div');
                    div2.style.float ='left';
                    div2.style.marginLeft ='30px';
                    div2.innerHTML =val[i][j][0];
                    let div3 =document.createElement('div');
                    div3.style.float ='left';
                    div3.style.width ='6px';
                    div3.style.height ='6px';
                    div3.style.borderRadius ='3px';
                    div3.style.backgroundColor ='#0f0f0f';
                    div1.appendChild(div2);
                    div1.appendChild(div3);
                    td.appendChild(div1);
                  }else{
                    td.innerHTML = val[i][j][0];
                  }
                  if(val[i][j][0]>high){
                    td.style.backgroundColor ='#ffd125';
                  }
                  else if(val[i][j][0]<low){
                    td.style.backgroundColor ='#ff3d3d';
                  }
                  else{
                    td.style.backgroundColor ='#c6deb5';
                  }
                }
            }
          }
        }
      },
      makecarb(val){
        for(let i=0;i<val.length;i++){
          if(val[i].length>0){
            let id = i*4+2;
            const tr = document.getElementById(id);
            for(let j=0;j<val[i].length;j++){
              if(val[i][j]!==0){
                /*const td = tr.getElementsByTagName('td')[val[i][j][0]];
                td.innerHTML = val[i][j][1];*/
                const td = tr.getElementsByTagName('td')[j];
                 td.innerHTML = val[i][j];
              }
            }
          }
        }
      },
      makeOth(val,flag){
        for(let i=0;i<val.length;i++){
          if(val[i].length>0){
            let id = i*4+3;
            const tr = document.getElementById(id);
            for(let j=0;j<val[i].length;j++){
              const td = tr.getElementsByTagName('td')[val[i][j]];
              const img = document.createElement('img');
              if(flag===0){
                img.src = '/static/Lgb Icon/Auto Suspend.png';
              }
              if(flag===1){
                img.src = '/static/Lgb Icon/Manual Suspend.png';
              }
              if(flag===2){
                img.src = '/static/Lgb Icon/Stop Patch .png';
              }
              if(flag===3){
                img.src = '/static/Lgb Icon/New Patch .png';
              }
              img.style.height = '12px';
              img.style.width = '12px';
              img.style.marginRight = '2px';
              img.style.float = 'left';
              td.appendChild(img);
            }
          }
        }
      },
      makeOth1(val,flag){
        console.log('makeOth1:', flag, val);
        for(let i=0;i<val.length;i++){
            let id =0;
            if(flag===4||flag===5||7===flag||8===flag||9===flag||10===flag||11===flag){
              id = i*4+4;
            }else{
              id = i*4+3;
            }
            const tr = document.getElementById(id);
            for(let j=0;j<val[i].length;j++){
                if(val[i][j]===1){
                  const td = tr.getElementsByTagName('td')[j];
                  const img = document.createElement('img');
                  img.style.height = '12px';
                  img.style.width = '12px';
                  if(flag===0){
                    img.src = '/static/Lgb Icon/Auto Suspend.png';
                  }
                  if(flag===1){
                    img.src = '/static/Lgb Icon/Manual Suspend.png';
                  }
                  if(flag===2){
                    img.src = '/static/Lgb Icon/Stop Patch .png';
                  }
                  if(flag===3){
                    img.src = '/static/Lgb Icon/New Patch .png';
                  }
                  if(flag===4){
                    img.src = '/static/Lgb Icon/Exercise.png';
                  }
                  if(flag===5){
                    img.src = '/static/Lgb Icon/Others.png';
                  }
                  if(flag===6){
                    img.src = '/static/Lgb Icon/temp basal.png';
                  }
                  if (7===flag) {
                    img.src = '/static/legend/automode/早餐.png';
                    img.style.height = '15px';
                  img.style.width = '22px';
                  } else if(flag===8){
                    img.src = '/static/legend/automode/中餐.png';
                    img.style.height = '15px';
                  img.style.width = '22px';
                  } else if(flag===9){
                    img.src = '/static/legend/automode/晚餐.png';
                    img.style.height = '15px';
                  img.style.width = '22px';
                  } else if(flag===10){
                    img.src = '/static/legend/automode/零食.png';
                    img.style.height = '15px';
                  img.style.width = '22px';
                  } else if(flag===11){
                    img.src = '/static/legend/automode/运动[30059].png';
                    img.style.height = '15px';
                    img.style.width = '22px';
                  } else if(flag===12){
                    img.src = '/static/legend/automode/进入自动模式.png';
                    img.style.height = '15px';
                    img.style.width = '15px';
                  } else if(flag===13){
                    img.src = '/static/legend/automode/退出自动模式.png';
                    img.style.height = '15px';
                    img.style.width = '15px';
                  }
                  img.style.marginRight = '2px';
                  img.style.marginLeft = '2px';
                  img.style.float = 'left';
                  td.appendChild(img);
                }
            }
        }
      },
      makeBolus(val, flag){
        for(let i=0;i<val.length;i++) {
          let leng =  val[i].length;
          let id = i * 4 + 3;
          const tr = document.getElementById(id);
          for (let k = 0; k <leng; k++) {
              if(val[i][k]!==0){
                const td = tr.getElementsByTagName('td')[k];
                if (flag[i][k]) {  // 带框
                  let div3 =document.createElement('div');
                  div3.style.float ='left';
                  div3.style.width ='32px';
                  div3.style.height ='18px';
                  div3.style.borderRadius ='4px';
                  div3.style.paddingTop ='2px';
                  div3.style.border ='1px solid #222';
                  div3.innerHTML = val[i][k].toFixed(2);
                  td.appendChild(div3);
                } else {  // 不带框
                  td.innerHTML = val[i][k].toFixed(2);
                }
              }
          }
        }
      },
      makeBolus2(val){
        for(let i=0;i<val.length;i++) {
          let leng =  val[i].length;
          if(leng>0){
            let id = i * 4 + 3;
            const tr = document.getElementById(id);
            for (let k = 0; k <leng; k++) {
              if(val[i][k].length>0){
                const td = tr.getElementsByTagName('td')[val[i][k][0]];

                let div3 =document.createElement('div');
                div3.style.float ='left';
                div3.style.width ='32px';
                div3.style.height ='18px';
                div3.style.borderRadius ='4px';
                div3.style.paddingTop ='2px';
                div3.style.border ='1px solid #222';
                div3.innerHTML = val[i][k][1].toFixed(2);

                td.appendChild(div3);
                //td.innerHTML = val[i][k][1].toFixed(1);
              }
            }
          }
        }
      },
      makeNoMeal(){
        let noMeal = this.noMeal,mt = this.mt;
        for(let i=0;i<noMeal.length;i++){
          for(let j=0;j<3;j++){
            if(noMeal[i][j]===0){
              let id = i*4+2;
              const tr = document.getElementById(id);
              const td = tr.getElementsByTagName('td')[mt[j][0]];
              const img = document.createElement('img');
              img.src = '/static/Lgb Icon/Missed Meal.png';
              img.className = 'insertImg';
              td.appendChild(img);
            }
          }
        }
        let mt1 = this.mt1;
        for(let i=0;i<3;i++) {
          const obj = document.getElementById('m'+i);
           obj.style.left = parseFloat(mt1[i][0]) / 24 * 100 + '%';
          obj.style.width = (parseFloat(mt1[i][1]) - parseFloat(mt1[i][0])) * 80+'px';
        }
      },
      makeNoPump(val){
          //console.log(val);
        for(let i=0;i<val.length;i++) {
            if(val[i]===1){
              let id = 'date'+i;
              const table = document.getElementById(id);
              const tr = table.getElementsByTagName('tr')[2];
              const td = tr.getElementsByTagName('td')[1];
              td.style.backgroundColor = '#ccc';
            }
        }
      },

      scroll(){
        this.wrapDiv = document.getElementById("wrap");
        this.contentDiv = document.getElementById("context-table");
        this.contentDiv1 = document.getElementById("context-table1");
        this.sliderWrap = document.getElementById("sliderWrap");
        this.slider = document.getElementById("slider");
        let tableRight= document.getElementById("table-right");
        //this.wrapDiv.style.height = '1800px';
        //tableRight.style.height  = '1900px';
        this.sliderWrap.style.visibility = 'visible';
        this.initScroll();
        //设置比例
        let scale =  this.wrapDiv.clientHeight /  this.contentDiv.clientHeight;
        if (scale < 1) {
          this.mouseFlag = true;
          let h1 =  this.sliderWrap.clientHeight * scale;
          h1 = (h1 < 50) ? 50 : h1;
          this.slider.style.height = h1 + "px";
          let y = 0;
          let that = this;
          //为wrap添加滚轮事件
          if (document.addEventListener){
            document.addEventListener('DOMMouseScroll',function (e) {
                if(that.mouseFlag){
                  //console.log('scroll');
                  let event1 = window.event|| e;
                  y = (event1.detail > 0) ? y + 8 : y - 8;
                  y = (y < 0) ? 0 : y;
                  let max = that.sliderWrap.clientHeight - that.slider.clientHeight;
                  y = (y > max + 1) ? max + 1 : y;
                  that.slider.style.top = y + "px";
                  scale = that.wrapDiv.clientHeight / that.contentDiv.clientHeight;
                  let y1 = -y / scale;
                  that.contentDiv.style.top = y1 + "px";
                  that.contentDiv1.style.top = y1 + "px";
                }
            },false)
          }
          this.wrapDiv.onmousewheel = function (e) {
            if (scale < 1) {
              let event1 = window.event || e;
              y = (event1.wheelDelta < 0) ? y + 8 : y - 8;
              y = (y < 0) ? 0 : y;
              let max =  that.sliderWrap.clientHeight -  that.slider.clientHeight;
              //console.log(scale, y, sliderWrap.clientHeight, slider.clientHeight);
              y = (y > max + 1) ? max + 1 : y;
              that.slider.style.top = y + "px";
              scale =  that.wrapDiv.clientHeight /  that.contentDiv.clientHeight;
              let y1 = -y / scale;
              that.contentDiv.style.top = y1 + "px";
              that.contentDiv1.style.top = y1 + "px";
            }
          }
        }
        else{
          this.wrapDiv.onmousewheel =null;
          if(document.addEventListener){
             this.mouseFlag = false;
          }
          this.sliderWrap.style.visibility = 'hidden';
          let height = this.contentDiv.clientHeight;
          tableRight.style.height  = height+72+'px';
          this.wrapDiv.style.height = height+2+'px';
        }
      },
      drag(ev){
        this.slider.className ='focus';
        let that = this;
        let scale =  this.wrapDiv.clientHeight /  this.contentDiv.clientHeight;
        let oEvent = ev || event;
        let pos = that.getPos(oEvent); //获取鼠标坐标
        this.disY = pos.y - this.slider.offsetTop;
        this.disX = pos.x - this.slider.offsetLeft;
        document.onmousemove =function (ev) {
          let oEvent = ev || event;
          let pos = that.getPos(oEvent);
          let t = pos.y - that.disY;
          t = (t<0) ?0:t;
          if (t > that.sliderWrap.clientHeight - that.slider.offsetHeight) {
            t = that.sliderWrap.clientHeight - that.slider.offsetHeight;
          }
          that.slider.style.top=t+'px';
          let t1 = -(t+1)/scale;
          that.contentDiv.style.top = t1 + "px";
          that.contentDiv1.style.top = t1 + "px";
          };
        document.onmouseup = function () {
          that.slider.className ='';
          document.onmousemove = null;
          document.onmouseup = null;
        };
        return false;//兼容firefox
      },
      initScroll(){
        this.slider.style.top = 0;
        this.contentDiv.style.top = 0;
        this.contentDiv1.style.top = 0;
      },
      /*获取鼠标坐标*/
      getPos(ev){
          let scrollTop=document.documentElement.scrollTop||document.body.scrollTop;
          let scrollLeft=document.documentElement.scrollLeft||document.body.scrollLeft;
         return {x: ev.clientX+scrollLeft, y: ev.clientY+scrollTop};
       },
      //  滚轮事件
       handleScroll() {
         let scrollTop = document.documentElement.scrollTop; //滑动的距离
         let heightTop = document.querySelector(".searchBar").getBoundingClientRect().top
         let heightTwoTop = document.querySelector(".searchBarTd").getBoundingClientRect().top
         if (heightTop <= 0|| heightTwoTop <= 25) {
           let top = scrollTop-373;
           document.getElementsByClassName(
            "searchBar"
          )[0].style.position = "relative";
          document.getElementsByClassName(
            "searchBar"
          )[0].style.zIndex = "500";
          document.getElementsByClassName(
            "searchBar"
          )[0].style.top = `${top}px`;
           document.getElementsByClassName(
            "searchBar"
          )[0].style.backgroundColor = '#fff';
           document.getElementsByClassName(
            "searchBar"
          )[1].style.position = "relative";
          document.getElementsByClassName(
            "searchBar"
          )[1].style.zIndex = "500";
          document.getElementsByClassName(
            "searchBar"
          )[1].style.top = `${top}px`;
          document.getElementsByClassName(
            "searchBar"
          )[1].style.width = '750px';
           document.getElementsByClassName(
            "searchBarRight"
          )[0].style.backgroundColor = '#fff';
          }
          if(scrollTop <= 340){
          document.getElementsByClassName(
            "searchBar"
          )[0].style.position = "";
          document.getElementsByClassName(
            "searchBar"
          )[0].style.zIndex = "";
          document.getElementsByClassName(
            "searchBar"
          )[0].style.top = "";
           document.getElementsByClassName(
            "searchBar"
          )[1].style.position = "";
          document.getElementsByClassName(
            "searchBar"
          )[1].style.zIndex = "";
          document.getElementsByClassName(
            "searchBar"
          )[1].style.top = "";
        }
       }
    },
    mounted: function () {
      window.addEventListener("scroll", this.handleScroll, true);
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.tz = parseInt(sessionStorage.getItem('tz'));
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      console.log(sessionStorage.getItem('st5'))
      if(!sessionStorage.getItem('st5')){
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time');
        console.log(chart_end_time);
        for (var d=0;d<3000;d++) {
          if (this.et>chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;
        this.weekmode = 'yyyyyyy';
        this.timeRange = format.formatterDate2(this.st)+'-'+format.formatterDate2(this.et)+', '+this.$t(this.whichDay);
      }else{
        this.st = parseInt(sessionStorage.getItem('st5'));
        this.et = parseInt(sessionStorage.getItem('et5'));
        this.weekmode =sessionStorage.getItem('week5');
        //this.timeRange =sessionStorage.getItem('timeRange5');
        this.timeRange = format.formatterDate2(this.st)+'-'+format.formatterDate2(this.et)+', '+this.$t(this.whichDay);
        //

      }
      sessionStorage.setItem('st5',this.st);
      sessionStorage.setItem('et5',this.et);
      sessionStorage.setItem('week5',this.weekmode);
      sessionStorage.setItem('timeRange5',this.timeRange);
      this.defaultDate1 = format.formatterDate4(this.st);
      this.defaultDate2 =format.formatterDate4(this.et);
      this.value1=new Date(this.st*1000);
      this.value2=new Date(this.et*1000);
      var count=(this.et-this.st)/86400+1;
      if (count>14) {
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time');
        console.log(chart_end_time);
        for (var d=0;d<3000;d++) {
          if (this.et>chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;
        this.weekmode = 'yyyyyyy';
        this.timeRange = format.formatterDate2(this.st)+'-'+format.formatterDate2(this.et)+', '+this.$t(this.whichDay);
      }
      //
      if (7==count) {
        this.timeRangeSelect=1;
      } else if (14==count) {
        this.timeRangeSelect=2;
      }

      //

      //
      this.ts = this.getTs(this.st,this.et);
      let param = {
        ts:this.ts,
        tz:this.tz,
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      //
      let daysNum=this.ts.length;

      let w1=document.getElementById("wrap");
      let w2=document.getElementById("wrap1");
      let w3=document.getElementById("sliderWrap");
      let w4=document.getElementById("table-wrapper");
      w1.style.height=(0+124*daysNum)+'px';
      w2.style.height=(0+124*daysNum)+'px';
      w3.style.height=(0+124*daysNum)+'px';
      w4.style.height=(100+124*daysNum)+'px';
      //
      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      param = B64.base64encode(JSON.stringify(param));
      auth.getLgb1(this,this.uid,param);
      //let that=this;

      /*
      auth.getDataMap(this, this.uid, function (res) {
        if (0!=res.error) {
          return;
        }
        var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
        //console.log(param)
        var ts_size=param.ts.length;
        //var time_offset=0;
        var cur_end=param.ts[ts_size-1][1];
        console.log(cur_end + ', '+end_time);
        for (var d=0; d<3000;d++) {
          if(cur_end>end_time) {
            cur_end -= 24*3600;
          } else {
            break;
          }
        }

        console.log(d)
        if (d)
          d -= 1;
        for (var i=0; i<ts_size; i++) {
          param.ts[i][0] -= 24*3600*d;
          param.ts[i][1] -= 24*3600*d;
        }


        //
        param = B64.base64encode(JSON.stringify(param));
        auth.getLgb1(that, that.uid, param);



      }) */
    },
    beforeDestroy: function () {
      window.removeEventListener("scroll", this.handleScroll, true);
    }
  }
</script>

<style scoped>
  .chart-container {
    width:100%;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select:none;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  .main-header-right .set{
    margin-left: 0;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }
  .main-wrapper{
    *height: 920px;
    width:97%;
    margin:0 auto 20px;
    position: relative;
  }
  .main-wrapper table{
    border-collapse: collapse;
    text-align: center;
    font-family:SFUIText-Regular;
    color:#282828;
    letter-spacing:-0.29px;
  }
  table td{
    border:1px solid  #d3d3d3;
    height:30px;
  }
  table .spe-td{
    border-top: none;
  }
  table .spe-td2{
    border-right: none;
  }
  .table-left{
    width: 23%;
    margin-top: 21px;
    word-wrap:break-word ;
    word-break: break-all;
    font-size:13px;
    float:left;
  }
  .searchBar {
    background-color: #fff;
  }
  .zh66{
    font-size:12px;
  }
  .table-right{
    width:77%;
    overflow-x: auto;
    margin-left: -1px;
    *overflow-y: hidden;
    font-size:13px;
    float: left;
  }
  /*滚动条*/
  #wrap{
    width: 1945px;
    *height:1800px;
    position:relative;
    overflow: hidden;
  }
  #wrap1{
    width: 100%;
    *height:1800px;
    position: relative;
    overflow: hidden;
  }
  #context-table,#context-table1{
    width: 100%;
    position: absolute;
    left:0;
    top:0;
  }
  #context-table1{
    width: 100%;
  }
  #sliderWrap{
    *height:1800px ;
    width:16px ;
    background: #eee;
    position: absolute;
    visibility: hidden;
    left:-21px;
    top: 52px;
    z-index: 100;
  }
  #slider{
    width: 10px;
    height: 40px;
    background: #bbb;
    border-radius: 4px;
    position: absolute;
    left: 3px;
    top: 0;
    cursor: pointer;
  }
  #slider.focus{
    background: #999;
  }
  .table-right table{
    min-width: 1529px;
  }
  .table2 td{
    min-width: 80px;
  }
  #title-table{
    background: #fff;
  }
  .table4 .spe-td3{
    border-left: none;
    border-right: none;
    text-align: left;
    min-width: 81px;
    position: relative;
  }
  .table4 .spe-td4{
    border-right:1px solid  #d3d3d3;
  }
  .table4 span{
    position: absolute;
    left:-15px;
    top:7px;
    z-index: 11;
  }
  .spe-td5 span{
    left:0;
  }


  .insertImg{
    height:8px;
    width:8px;
  }
  table .Bglabel{
    font-size:14px;
  }
  .tip{
    width: 1945px;
    height:20px;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    letter-spacing:-0.29px;
    margin-bottom: 1px;
    text-align: right;
    position: relative;
  }
  .tip span{
    background:#9cd4ff;
    display: inline-block;
    border-radius:4px 4px 0 0;
    height:20px;
    width: 60px;
    line-height: 20px;
    *margin-right: 200px;
    text-align: center;
    position: absolute;
    top:0;
    left:0;
  }
  .fr6 span{
    white-space: nowrap;
  }

  .po6 span{
   overflow: hidden;
  }


  .legend-group{
    width:95%;
    margin:15px auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
  }
  .legend{
    float:left;
    margin-bottom: 12px;
    height:20px;
    line-height: 20px;
    text-align: center;
    margin-right: 42px;
  }
  .spe1{
    margin-right: 25px;
    margin-bottom: 0px;
  }
  .spe2{
    margin-right: 84px;
  }
  .spe3{
    margin-right: 98px;
  }
  .spe4{
    margin-right: 95px;
  }
  .spe5{
    margin-right: 75px;
  }
  .spe6{
    margin-bottom: 0px;
  }
  .spe7 {
    margin-left:0px;
    margin-right:25px;
  }
  .legend img{
    margin-right: 8px;
  }
  .img-spe{
    margin-bottom: -2px;
  }
  .img-spe1{
    margin-bottom: 3px;
  }
  .img-spe2{
    margin-bottom: -5px;
  }

  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .dialog-body .time-range{
    height:35px;
    line-height: 35px;
  }
  .duration{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  .duration span{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-left: 18px;
    margin-right: 15px;
  }
  .duration select{
    height: 30px;
    width: 120px;
    border-radius: 4px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 20px;
    margin-left: 20px;
  }
  .time-range .start{
    float: left;
    margin-bottom: 20px;
    margin-right: 15%;
  }
  .time-range .end{
    float: left;
    margin-bottom: 20px;
  }
  .time-range .block{
    float: left;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .weeks{
    width:92%;
    margin:0 auto;
    margin-top: 30px;
  }
  .weken{
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .weeks span{
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#6d6d6d;
    letter-spacing:-0.39px;
    text-align:left;
    margin-left: 4%;
  }
  .weeks .tittle{
    margin: 0 7% 0 0;
    display: block;
    float: left;
    margin-bottom: 10px;
  }
  .weeks label{
    background: url("../../assets/select yes.png") left 1px no-repeat;
    cursor: pointer;
    padding-left: 18px;
  }
  .weeks .no{
    background: url("../../assets/select no.png") left 1px no-repeat;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }
 .to{
    margin-right: 40px;
  }
 .zh6{
   margin-right: 30px;
 }
  .zh2 p{
    font-size: 16px;
  }
  .zh3 span{
    font-size: 15px;
  }
  .weeks .zh4{
    margin-right: 10px;
  }
  .weeks .zh5{
    margin-right: 25px;
  }
  .weeks .de5{
    margin-right: 21px;
  }
  .weeks .it5{
    margin-right: 15px;
  }
  .weeks .it2{
    margin-left: 3.8%;
  }
  .weeks .po5{
    margin-right: 24px;
  }
  .weeks .po2{
    margin-left: 4.1%;
  }
  .weeks .du5{
    margin-right: 54px;
  }
  .weeks .du2{
    margin-left: 4.6%;
  }
  .weeks .fr3 {
    margin-left: 3%;
  }
  .weeks .sw5{
    margin-right: 51px;
  }
  .weeks .sw2{
    margin-left: 5%;
  }
  .weeks .cz5{
    margin-right: 66px;
  }
  .weeks .cz2{
    margin-left: 4%;
  }
  .zh8 .legend{
    margin-right: 70px;
  }
  .es8 .legend{
    margin-right: 30px;
  }
  .de8 .legend{
    margin-right: 20px;
  }
  .zh8 .zh9{
    margin-right: 30px;
  }
  .es8 .es9{
    margin-right: 10px;
  }
  .de8 .de9{
    margin-right: 35px;
  }
  .de8 .de10{
    margin-right: 35px;
  }
  .zh8 .zh10{
    margin-right: 63px;
  }
  .es8 .es10{
    margin-right: 35px;
  }
  .zh8 .zh11{
    margin-right: 128px;
  }
  .es8 .es11{
    margin-right: 85px;
  }
  .zh8 .zh12{
    margin-right: 108px;
  }
  .es8 .es12{
    margin-right: 75px;
  }
  .es8 .es13{
    margin-right: 75px;
  }
  .es8 .es15{
    margin-right: 55px;
  }
  .zh8 .zh13{
    margin-right:0;
  }
  .it8 .legend{
    margin-right: 30px;
  }
  .po8 .legend{
    margin-right: 35px;
  }
  .du8 .legend{
    margin-right: 28px;
  }
  .du8 .spe1{
    margin-right:0;
  }
  .fr8 .spe2{
    margin-right:48px;
  }
  .fr8 .spe3,.fr8 .spe4,.fr8 .spe5{
    margin-right:38px;
  }
  .sw8 .legend{
    margin-right: 30px;
  }
  .sw8 .spe2{
    margin-right: 75px;
  }
  .sw8 .spe3{
    margin-right: 105px;
  }
  .sw8 .spe4{
    margin-right: 105px;
  }
  .sw8 .spe5{
    margin-right: 40px;
  }
  .sw8 .spe6{
    margin-right: 60px;
  }
  .legend-group .cz10,.legend-group .cz11,.legend-group .cz12{
    margin-right: 52px;
  }
  @media screen and (max-width: 1300px){
    .legend{
      margin-right: 28px;
    }
    .spe2{
       margin-right: 68px;
     }
    .spe3{
      margin-right: 88px;
    }
    .spe4{
      margin-right: 80px;
    }
    .spe5{
      margin-right: 61px;
    }
    .spe1{
      margin-right: 0;
    }
    .zh8 .legend{
      margin-right: 45px;
    }
    .zh8 .zh9{
      margin-right: 30px;
    }
    .zh8 .zh10{
      margin-right: 43px;
    }
    .zh8 .zh14{
      margin-right:65px;
    }
    .zh8 .zh11{
      margin-right: 96px;
    }
    .zh8 .zh12{
      margin-right: 86px;
    }
    .zh8 .zh13{
      margin-right:0;
    }
    .es8 .legend{
      margin-right: 20px;
    }
    .es8 .es9{
      margin-right: 0;
    }
    .es8 .es10{
      margin-right: 25px;
    }
    .es8 .es11{
      margin-right:75px;
    }
    .es8 .es12{
      margin-right: 60px;
    }
    .es8 .es13{
      margin-right: 64px;
    }
    .es8 .es15{
      margin-right:35px;
    }
    .es8 .es16{
      margin-right:0;
    }
    .it8 .legend{
      margin-right: 24px;
    }
    .multiBg{
      float:left;
      width:6px;
      height:6px;
      border-radius: 3px;
      background-color: #0f0f0f
    }
    .po8 .legend{
      margin-right: 22px;
    }
    .du8 .legend{
      margin-right: 15px;
    }
    .du8 .spe1{
      margin-right:0;
    }
    .sw8 .legend{
      margin-right: 15px;
    }
    .sw8 .spe2{
      margin-right: 58px;
    }
    .sw8 .spe3{
      margin-right: 85px;
    }
    .sw8 .spe4{
      margin-right: 80px;
    }
    .sw8 .spe5{
      margin-right: 40px;
    }
    .sw8 .spe6{
      margin-right: 60px;
    }
    .sw8 .spe1, .sw8 .sw9{
      margin-right: 0;
    }
    .legend-group .cz10,.legend-group .cz11,.legend-group .cz12{
      margin-right: 42px;
    }
  }
</style>






// WEBPACK FOOTER //
// chart5-2.vue?dbef067a